import React, { useState, useEffect, useRef } from "react";
function ItemDropdown({ item, isOpen, onToggle, onSelect, name, values }) {
  const ref = useRef(null);

  // Close dropdown if click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onToggle(null); // close this dropdown
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  return (
    <div className="ms-2 dropdown" ref={ref}>
      <button
        type="button"
        className="btn btn-primary dropdown-toggle "
        data-bs-toggle="dropdown"
        onClick={(e) => onToggle(isOpen ? null : item.id)}
      >
        {name}
      </button>
      {isOpen && (
        <ul className={`dropdown-menu ${isOpen ? "show" : ""}`}>
          {values.map((v) => (
            <li key={v.id} onClick={() => onSelect(v.id)}>
              <a className="dropdown-item">{v.name}</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
export default ItemDropdown;
